var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDbquotes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42543 4.56062C5.66013 6.97873 3.56834 9.79323 3.15006 13.0041C2.49888 18.0026 6.96898 20.4493 9.23393 18.251C11.4989 16.0527 10.1412 13.2624 8.50113 12.4997C6.86108 11.737 5.85813 12.0026 6.03308 10.9834C6.20803 9.96418 8.54133 7.13828 10.5912 5.82223C10.7272 5.70658 10.779 5.48218 10.648 5.31193C10.5619 5.19998 10.3929 4.98041 10.1412 4.65319C9.92103 4.36706 9.71013 4.37777 9.42543 4.56062Z",
    fill: "#85C2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3395 4.56062C15.5742 6.97873 13.4824 9.79323 13.0641 13.0041C12.413 18.0026 16.8831 20.4493 19.148 18.251C21.413 16.0527 20.0553 13.2624 18.4152 12.4997C16.7752 11.737 15.7722 12.0026 15.9472 10.9834C16.1221 9.96418 18.4554 7.13828 20.5053 5.82223C20.6413 5.70658 20.6931 5.48218 20.5621 5.31193C20.476 5.19998 20.307 4.98041 20.0553 4.65319C19.8351 4.36706 19.6242 4.37777 19.3395 4.56062Z",
    fill: "#85C2FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDbquotes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dbquotes.7cad025abf988c8005c0eeff307b523c.svg";